import React from 'react';
import cn from 'classnames';

import Action from '@components/Button/Action';
import Header from '@components/Modals/Header';
import Help from '../Help';

import styles from './DiskAccess.module.scss';
import { useTheme } from '@hooks/use-theme';

const clay = '/img/messages/clay.png';
const later = '/img/messages/later.png';
const lock = '/img/messages/lock.png';
const vault = '/img/messages/vault.png';

function Item({ className = null, children, icon }) {
  const [theme] = useTheme();
  return (
    <div className={cn(styles.item, className, theme === 'light' && styles.itemLight)}>
      <span className={styles.icon} style={{ backgroundImage: `url(${icon})` }} />
      <div className={styles.content}>{children}</div>
    </div>
  );
}

export default function DiskAccess({
  provider,
  next,
  hasDiskAccess,
  hasIntegration,
  prev,
  checkDiskAccess,
  setupIntegration,
  performSync,
  forceDarkMode,
}) {
  function nextPage() {
    if (hasDiskAccess && !hasIntegration) {
      setupIntegration();
    }

    setTimeout(() => {
      performSync();
    }, 100);

    next();
  }

  function handleDiskAccess(e) {
    e.preventDefault();
    window.localStorage.setItem('mac_disk_access', 'true');
    window.desktopIntegrations.integration.authorizeDiskAccess(provider);

    const start = Date.now();

    let interval = setInterval(async () => {
      if (Date.now() - start >= 300000) {
        clearInterval(interval);
        return;
      }

      const access = await checkDiskAccess();
      if (!access) {
        return;
      }

      setupIntegration();
      clearInterval(interval);
    }, 2000);
  }

  return (
    <>
      <Header prev={prev}>Enable Full Disk Access</Header>
      <div className={styles.container}>
        <p>
          To import your relationships please enable Full Disk Access.{' '}
          <a
            className="text-default"
            href="https://clay.earth/security-and-privacy"
            target="_blank"
          >
            Learn more
          </a>{' '}
          about Full Disk Access.
        </p>
        <Item className={styles.vault} icon={vault}>
          <div className={styles.contentContainer}>
            <div className={styles.primary}>
              Open Security &amp; Privacy in the System Preferences
            </div>
            <div className={styles.accessory}>
              <Action onClick={handleDiskAccess} forceDarkMode={forceDarkMode}>
                Open
              </Action>
            </div>
          </div>
        </Item>
        <Item className={styles.lock} icon={lock}>
          Click the <strong className="text-default">lock icon</strong> in the bottom left corner to
          allow changes
        </Item>
        <Item className={styles.app} icon={clay}>
          Tick the <strong className="text-default">checkbox</strong> next to the Clay icon to
          enable Full Disk Access
        </Item>
        <Item className={styles.later} icon={later}>
          Choose “<strong className="text-default">Later</strong>” when asked whether to quit Clay.
        </Item>
        <Help next={hasDiskAccess && nextPage} text="Sync Now" forceDarkMode={forceDarkMode} />
      </div>
    </>
  );
}
